export interface TableSelectFilterOption<T extends string> {
  label: string;
  value: T;
}

interface TableSelectFilterProps<T extends string> {
  label: string;
  value: T;
  options: TableSelectFilterOption<T>[];
  onChange: (newValue: T) => void;
}

export const TableSelectFilter = <T extends string>({ label, value, options, onChange }: TableSelectFilterProps<T>) => {
  return (
    <div className="relative inline-flex items-center">
      <label className="sr-only" htmlFor={`table-select-filter-${label}`}>
        {label}
      </label>
      <select
        id={`table-select-filter-${label}`}
        className="rounded-md border border-primary-std bg-primary-std py-1.5 pl-3 pr-8 text-sm text-primary-std focus:outline-none focus:ring-1 focus:ring-primary-std"
        value={value}
        onChange={event => onChange(event.target.value as T)}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.value === 'All' ? label : option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
